import { ReactNode, useMemo, type JSX } from 'react';

import { useLocation } from 'react-router';
import { NotFound, paths } from 'shared/base';

import { useAuth } from '@/context/auth';
import { getConditionalRoutes } from '@/utils/getConditionalRoutes';

interface Props {
  children: ReactNode;
}

export function ConditionalRoutesGuard({ children }: Props) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const conditionalRoutes = useMemo(() => getConditionalRoutes(user), [user]);

  const isForbidden = conditionalRoutes.some(
    (route) => route.path === pathname && !route.isAllowed,
  );

  if (isForbidden) {
    return <NotFound returnTo={paths.platform.index} />;
  }

  return children as JSX.Element;
}
